import API from '../../api/api';
import {updateOrderSummary} from '../orderSummaryActions';

export default function fetchOrderSummary() {
  return dispatch => dispatch(API.doNetworkRequest('/v2/order-summary',
    undefined, undefined, 'GET'))
    .then((response) => {
      if (response && response.status === 200) {
        return dispatch(updateOrderSummary(response.msg));
      }
      throw new Error(`Error fetching order summary: ${JSON.stringify(response)}`);
    })
    .catch((error) => {
      throw new Error(`Caught error fetching order summary: ${error}`);
    });
}
